
import { useEffect, useState } from 'react';

import fetchRecentlyViewed from 'Api/RecentlyViewed/recently-viewed';

/**
 * Custom hook to fetch and return recently viewed hits.
 * @param {*} fetchHits
 * @param {*} hitsToDisplay
 * @returns
 */
const useFetchRecentlyViewed = (hitsToDisplay, slugsToExclude) => {
  const [recentlyViewedHits, setRecentlyViewedHits] = useState([]);

  useEffect(() => {
    const loadRecentlyViewedHits = async () => {
      try {
        const hits = await fetchRecentlyViewed(hitsToDisplay, slugsToExclude);
        setRecentlyViewedHits(hits);
      } catch (error) { /* */ }
    };


    loadRecentlyViewedHits();
  }, [hitsToDisplay, slugsToExclude]);

  return { recentlyViewedHits };
};

export default useFetchRecentlyViewed;
